<template>
  <base-text-field :model-value="modelValue" :label="label" :placeholder="placeholder" :rules="internalRules" :required="required" ref="input" @update:model-value="handleInput">
    <template #prefix>
      {{ selectedRegion.label }}
    </template>
  </base-text-field>
</template>

<script>
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
const formatter = PhoneNumberFormat;
const phoneUtil = PhoneNumberUtil.getInstance();
import BaseTextField from "@/components/base/BaseTextField";
import Cleave from "cleave.js";
import "cleave.js/dist/addons/cleave-phone.us";

export default {
  components: {
    BaseTextField,
  },
  emits: ["update:modelValue", "update:e164"],
  props: {
    modelValue: [String, Number],
    label: String,
    placeholder: String,
    rules: {
      type: Array,
      default: () => [],
    },
    required: Boolean,
  },
  data() {
    return {
      cleave: null,
      selectedRegionCode: this.modelValue ? phoneUtil.getRegionCodeForNumber(phoneUtil.parseAndKeepRawInput(this.modelValue)) : "US",
      rawInput: this.modelValue ? phoneUtil.parse(this.modelValue).getNationalNumber() : null,
      regions: [
        { region: "US", label: "US +1", prefix: "+1" },
        { region: "PR", label: "PR +1", prefix: "+1" },
      ],
    };
  },
  computed: {
    selectedRegion() {
      return this.regions.find((items) => items.region === this.selectedRegionCode) || {};
    },
    e164() {
      try {
        return phoneUtil.format(phoneUtil.parse(this.selectedRegion.prefix + this.rawInput), formatter.E164);
      } catch (error) {
        return "";
      }
    },
    isValid() {
      try {
        return phoneUtil.isValidNumber(phoneUtil.parse(this.e164));
      } catch (error) {
        return false;
      }
    },
    internalRules() {
      return [() => !!this.isValid || "Invalid Phone Number", ...this.rules];
    },
  },
  mounted() {
    this.cleave = new Cleave(this.$refs.input.$refs.input, {
      phone: true,
      phoneRegionCode: this.selectedRegionCode,
      delimiter: "-",
      onValueChanged: (e) => {
        this.$nextTick(() => {
          this.rawInput = e.target.rawValue;
          this.$emit("update:modelValue", e.target.value);
          this.$emit("update:e164", this.e164);
        });
      },
    });

    this.cleave.setRawValue(this.rawInput);
  },
  beforeUnmount() {
    this.cleave.destroy();
  },
  methods: {
    handleInput(event) {
      if (event === null) {
        this.cleave.setRawValue(null);
      }
    },
  },
  watch: {
    modelValue() {
      if (this.modelValue) {
        try {
          this.rawInput = phoneUtil.parseAndKeepRawInput(this.modelValue, this.selectedRegion.region).getNationalNumber();
          this.cleave.setRawValue(this.rawInput);
          // eslint-disable-next-line no-empty
        } catch (error) {}
      }
    },
  },
};
</script>
